import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "moon-altitude-graph-container position-relative fit-content" }
const _hoisted_2 = { class: "moon-text" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "moon-altitude-text mb-1" }, "Wysokość", -1)
const _hoisted_4 = { class: "moon-altitude-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.getMoonAltitude), 1)
      ])
    ])
  ]))
}